import { decorate, observable, action, autorun } from "mobx";
import { formatClipsFromSporty } from "../utils/format";

const SORT_BY_OPTIONS = [
  { label: "Created At", value: "createdAt" },
  { label: "Title", value: "title" }
];

const DEFAULT_SORT_OPTION = { label: "Created At", value: "createdAt" };

class MyClipsStore {
  totalVideos = 0;
  videosPerPage = 12;
  page = 0;
  videos = [];
  title = "";
  sortByOptions = SORT_BY_OPTIONS;
  sortBy = DEFAULT_SORT_OPTION;

  constructor(sportyApi) {
    this.sportyApi = sportyApi;
  }

  initialize(options) {
    this.videosPerPage = options.videosPerPage || this.videosPerPage;
    this.disposer = autorun(
      () => {
        this.sportyApi
          .getUserClips({
            title: this.title,
            limit: this.videosPerPage,
            page: this.page,
            sortBy: this.sortBy.value
          })
          .then(result => {
            this.videos = formatClipsFromSporty(result.userClips);
            this.totalVideos = result.total;
          });
      },
      { delay: 500 }
    );
  }

  refreshClips() {
    return this.sportyApi
      .getUserClips({
        title: this.title,
        limit: this.videosPerPage,
        page: this.page,
        sortBy: this.sortBy.value
      })
      .then(result => {
        this.videos = formatClipsFromSporty(result.userClips);
        this.totalVideos = result.total;
      });
  }

  dispose() {
    this.disposer && this.disposer();
  }

  setTitle(title) {
    this.page = 0;
    this.title = title;
  }

  setSortBy(value) {
    if (value !== this.sortBy.label) {
      this.page = 0;
      this.sortBy = this.sortByOptions.find(option => option.value === value);
    }
  }

  setClipsPerPage(perPage) {
    this.page = 0;
    this.videosPerPage = perPage;
  }

  setPage(page) {
    this.page = page;
  }
}

decorate(MyClipsStore, {
  totalVideos: observable,
  videosPerPage: observable,
  page: observable,
  videos: observable,
  title: observable,
  sortBy: observable,
  setClipsPerPage: action,
  setPage: action,
  setSortBy: action
});

export default MyClipsStore;



// WEBPACK FOOTER //
// ./src/stores/MyClipsStore.js